// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IBusinessTransactionType {
    id: number;
    businessTransactionCategoryTypeId: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class BusinessTransactionType implements IBusinessTransactionType, IBaseType {
    public id: number;
    public businessTransactionCategoryTypeId: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Audit Assessment Excise Penalties Interest Tax Credit BusinessTransactionType
	**/
    get AuditAssessmentExcisePenaltiesInterestTaxCredit(): IBusinessTransactionType {
        return this.FromId(1127);
    }
    /**
		Returns Notice of Assessment Excise Penalties Interest Tax Credit BusinessTransactionType
	**/
    get NoticeofAssessmentExcisePenaltiesInterestTaxCredit(): IBusinessTransactionType {
        return this.FromId(1128);
    }
    /**
		Returns Fuel Tax Adjustment Excise Penalties Interest Tax Credit BusinessTransactionType
	**/
    get FuelTaxAdjustmentExcisePenaltiesInterestTaxCredit(): IBusinessTransactionType {
        return this.FromId(1129);
    }
    /**
		Returns Fuel Tax Adjustment UST Penalties Interest Tax Credit BusinessTransactionType
	**/
    get FuelTaxAdjustmentUSTPenaltiesInterestTaxCredit(): IBusinessTransactionType {
        return this.FromId(1130);
    }
    /**
		Returns Audit Assessment UST Penalties Interest Tax Credit BusinessTransactionType
	**/
    get AuditAssessmentUSTPenaltiesInterestTaxCredit(): IBusinessTransactionType {
        return this.FromId(1131);
    }
    /**
		Returns Notice of Assessment UST Penalties Interest Tax Credit BusinessTransactionType
	**/
    get NoticeofAssessmentUSTPenaltiesInterestTaxCredit(): IBusinessTransactionType {
        return this.FromId(1132);
    }
    /**
		Returns Miscellaneous Refund BusinessTransactionType
	**/
    get MiscellaneousReversal(): IBusinessTransactionType {
        return this.FromId(1136);
    }
    /**
		Returns Collections Payment BusinessTransactionType
	**/
    get CollectionsPayment(): IBusinessTransactionType {
        return this.FromId(1138);
    }
    /**
		Returns Motor Carrier Replace Cab Card BusinessTransactionType
	**/
    get MCAReplaceCabCard(): IBusinessTransactionType {
        return this.FromId(1157);
    }
    /**
		Returns Motor Carrier File Quarterly Report IFTA BusinessTransactionType
	**/
    get MCAFileQuarterlyReportIFTA(): IBusinessTransactionType {
        return this.FromId(1159);
    }
    /**
		Returns Motor Carrier Add Decals IFTA BusinessTransactionType
	**/
    get MCAAddDecalsIFTA(): IBusinessTransactionType {
        return this.FromId(1160);
    }
    /**
		Returns Motor Carrier Amend Quarterly Report IFTA BusinessTransactionType
	**/
    get MCAAmendQuarterlyReportIFTA(): IBusinessTransactionType {
        return this.FromId(1161);
    }
    /**
		Returns Motor Carrier Duplicate IFTA License BusinessTransactionType
	**/
    get MCADuplicateIFTALicense(): IBusinessTransactionType {
        return this.FromId(1162);
    }
    /**
		Returns Motor Carrier Renew IFTA License BusinessTransactionType
	**/
    get MCARenewIFTALicense(): IBusinessTransactionType {
        return this.FromId(1163);
    }
    /**
		Returns Motor Carrier Error Correction BusinessTransactionType
	**/
    get MCAErrorCorrection(): IBusinessTransactionType {
        return this.FromId(1164);
    }
    /**
		Returns Motor Carrier Error Correction- Mileage BusinessTransactionType
	**/
    get MCAErrorCorrectionMileage(): IBusinessTransactionType {
        return this.FromId(1166);
    }
    /**
		Returns Motor Carrier Error Correction- Delete Vehicle BusinessTransactionType
	**/
    get MCAErrorCorrectionDeleteVehicle(): IBusinessTransactionType {
        return this.FromId(1167);
    }
    /**
		Returns Charitable Event TRP BusinessTransactionType
	**/
    get CharitableEventTRP(): IBusinessTransactionType {
        return this.FromId(1170);
    }
    /**
		Returns Refund Commercial Permit BusinessTransactionType
	**/
    get RefundCommercialPermit(): IBusinessTransactionType {
        return this.FromId(1174);
    }
    /**
		Returns DSPC Sold Notice BusinessTransactionType
	**/
    get DealerPublicConsignmentSalesNotice(): IBusinessTransactionType {
        return this.FromId(1179);
    }
    /**
		Returns Title Only BusinessTransactionType
	**/
    get TitleOnly(): IBusinessTransactionType {
        return this.FromId(1);
    }
    /**
		Returns Registration Only BusinessTransactionType
	**/
    get RegistrationOnly(): IBusinessTransactionType {
        return this.FromId(2);
    }
    /**
		Returns Title and Registration BusinessTransactionType
	**/
    get TitleandRegistration(): IBusinessTransactionType {
        return this.FromId(3);
    }
    /**
		Returns Commercial Envelope Permit BusinessTransactionType
	**/
    get CommercialEnvelopePermit(): IBusinessTransactionType {
        return this.FromId(4);
    }
    /**
		Returns Issue Temporary Placard BusinessTransactionType
	**/
    get IssueTemporaryPlacard(): IBusinessTransactionType {
        return this.FromId(5);
    }
    /**
		Returns Replace Temporary Placard BusinessTransactionType
	**/
    get ReplaceTemporaryPlacard(): IBusinessTransactionType {
        return this.FromId(6);
    }
    /**
		Returns Renew Permanent Placard BusinessTransactionType
	**/
    get RenewPermanentPlacard(): IBusinessTransactionType {
        return this.FromId(7);
    }
    /**
		Returns Cancel Temporary Placard BusinessTransactionType
	**/
    get CancelTemporaryPlacard(): IBusinessTransactionType {
        return this.FromId(8);
    }
    /**
		Returns Issue Permanent Placard BusinessTransactionType
	**/
    get IssuePermanentPlacard(): IBusinessTransactionType {
        return this.FromId(9);
    }
    /**
		Returns Replace Permanent Placard BusinessTransactionType
	**/
    get ReplacePermanentPlacard(): IBusinessTransactionType {
        return this.FromId(10);
    }
    /**
		Returns Cancel Permanent Placard BusinessTransactionType
	**/
    get CancelPermanentPlacard(): IBusinessTransactionType {
        return this.FromId(11);
    }
    /**
		Returns Issue Permit BusinessTransactionType
	**/
    get IssuePermit(): IBusinessTransactionType {
        return this.FromId(12);
    }
    /**
		Returns Reprint Permit BusinessTransactionType
	**/
    get ReprintPermit(): IBusinessTransactionType {
        return this.FromId(13);
    }
    /**
		Returns Cancel Permit BusinessTransactionType
	**/
    get CancelPermit(): IBusinessTransactionType {
        return this.FromId(14);
    }
    /**
		Returns Print Title BusinessTransactionType
	**/
    get PrintTitle(): IBusinessTransactionType {
        return this.FromId(15);
    }
    /**
		Returns Manage Liens and Brands BusinessTransactionType
	**/
    get ManageLiensandBrands(): IBusinessTransactionType {
        return this.FromId(16);
    }
    /**
		Returns Cancel Title BusinessTransactionType
	**/
    get CancelTitle(): IBusinessTransactionType {
        return this.FromId(17);
    }
    /**
		Returns Renew Registration BusinessTransactionType
	**/
    get RenewRegistration(): IBusinessTransactionType {
        return this.FromId(18);
    }
    /**
		Returns Duplicate Registration BusinessTransactionType
	**/
    get DuplicateRegistration(): IBusinessTransactionType {
        return this.FromId(19);
    }
    /**
		Returns Update Registration BusinessTransactionType
	**/
    get UpdateRegistration(): IBusinessTransactionType {
        return this.FromId(20);
    }
    /**
		Returns Suspend Registration BusinessTransactionType
	**/
    get SuspendRegistration(): IBusinessTransactionType {
        return this.FromId(21);
    }
    /**
		Returns Add Insurance BusinessTransactionType
	**/
    get AddInsurance(): IBusinessTransactionType {
        return this.FromId(22);
    }
    /**
		Returns Update Insurance BusinessTransactionType
	**/
    get UpdateInsurance(): IBusinessTransactionType {
        return this.FromId(23);
    }
    /**
		Returns Abandoned Vehicle BusinessTransactionType
	**/
    get AbandonedVehicle(): IBusinessTransactionType {
        return this.FromId(24);
    }
    /**
		Returns Sold Notice BusinessTransactionType
	**/
    get SoldNotice(): IBusinessTransactionType {
        return this.FromId(25);
    }
    /**
		Returns Remove Sold Notice BusinessTransactionType
	**/
    get RemoveSoldNotice(): IBusinessTransactionType {
        return this.FromId(26);
    }
    /**
		Returns Add Brand BusinessTransactionType
	**/
    get AddBrand(): IBusinessTransactionType {
        return this.FromId(27);
    }
    /**
		Returns Maintain Brand BusinessTransactionType
	**/
    get MaintainBrand(): IBusinessTransactionType {
        return this.FromId(28);
    }
    /**
		Returns Checkout BusinessTransactionType
	**/
    get Checkout(): IBusinessTransactionType {
        return this.FromId(29);
    }
    /**
		Returns Receipt Management BusinessTransactionType
	**/
    get ReceiptManagement(): IBusinessTransactionType {
        return this.FromId(30);
    }
    /**
		Returns LECU Audit Report BusinessTransactionType
	**/
    get LECUAuditReport(): IBusinessTransactionType {
        return this.FromId(31);
    }
    /**
		Returns IA Audit Report BusinessTransactionType
	**/
    get IAAuditReport(): IBusinessTransactionType {
        return this.FromId(32);
    }
    /**
		Returns Reinstate Registration BusinessTransactionType
	**/
    get ReinstateRegistration(): IBusinessTransactionType {
        return this.FromId(33);
    }
    /**
		Returns Void Registration BusinessTransactionType
	**/
    get VoidRegistration(): IBusinessTransactionType {
        return this.FromId(34);
    }
    /**
		Returns Void Title BusinessTransactionType
	**/
    get VoidTitle(): IBusinessTransactionType {
        return this.FromId(35);
    }
    /**
		Returns Void Title and Registration BusinessTransactionType
	**/
    get VoidTitleandRegistration(): IBusinessTransactionType {
        return this.FromId(36);
    }
    /**
		Returns Revoke Registration BusinessTransactionType
	**/
    get RevokeRegistration(): IBusinessTransactionType {
        return this.FromId(37);
    }
    /**
		Returns Credential Issuance BusinessTransactionType
	**/
    get CredentialIssuance(): IBusinessTransactionType {
        return this.FromId(38);
    }
    /**
		Returns MVM Refund BusinessTransactionType
	**/
    get MVMRefund(): IBusinessTransactionType {
        return this.FromId(39);
    }
    /**
		Returns Issue GF Decal BusinessTransactionType
	**/
    get IssueGFDecal(): IBusinessTransactionType {
        return this.FromId(40);
    }
    /**
		Returns Replace OHV Decal BusinessTransactionType
	**/
    get ReplaceGFDecal(): IBusinessTransactionType {
        return this.FromId(41);
    }
    /**
		Returns Renew OHV Decal BusinessTransactionType
	**/
    get RenewOHVDecal(): IBusinessTransactionType {
        return this.FromId(42);
    }
    /**
		Returns ABV Report (E-Crushed) BusinessTransactionType
	**/
    get ABVReportECrushed(): IBusinessTransactionType {
        return this.FromId(43);
    }
    /**
		Returns ABV Report (E-Request) BusinessTransactionType
	**/
    get ABVReportERequest(): IBusinessTransactionType {
        return this.FromId(44);
    }
    /**
		Returns Title Mobile Home BusinessTransactionType
	**/
    get TitleMobileHome(): IBusinessTransactionType {
        return this.FromId(45);
    }
    /**
		Returns EZ Lienholder MVR BusinessTransactionType
	**/
    get EZLienholderMVR(): IBusinessTransactionType {
        return this.FromId(46);
    }
    /**
		Returns Void Permit BusinessTransactionType
	**/
    get VoidPermit(): IBusinessTransactionType {
        return this.FromId(47);
    }
    /**
		Returns Duplicate Mobile Home Title BusinessTransactionType
	**/
    get DuplicateMobileHomeTitle(): IBusinessTransactionType {
        return this.FromId(48);
    }
    /**
		Returns Reserve Special Plate BusinessTransactionType
	**/
    get ReserveSpecialPlate(): IBusinessTransactionType {
        return this.FromId(49);
    }
    /**
		Returns Temporary Registration Plate BusinessTransactionType
	**/
    get IssueTRP(): IBusinessTransactionType {
        return this.FromId(50);
    }
    /**
		Returns Homemade Vehicle Permit BusinessTransactionType
	**/
    get HomemadeVehiclePermit(): IBusinessTransactionType {
        return this.FromId(51);
    }
    /**
		Returns Cancel Registration BusinessTransactionType
	**/
    get CancelRegistration(): IBusinessTransactionType {
        return this.FromId(52);
    }
    /**
		Returns Miscellaneous Transaction BusinessTransactionType
	**/
    get MiscellaneousTransaction(): IBusinessTransactionType {
        return this.FromId(53);
    }
    /**
		Returns Miscellaneous Transaction Refund BusinessTransactionType
	**/
    get MiscellaneousTransactionRefund(): IBusinessTransactionType {
        return this.FromId(54);
    }
    /**
		Returns Motor Carrier BusinessTransactionType
	**/
    get MotorCarrier(): IBusinessTransactionType {
        return this.FromId(55);
    }
    /**
		Returns Fund Customer Account BusinessTransactionType
	**/
    get FundCustomerAccount(): IBusinessTransactionType {
        return this.FromId(56);
    }
    /**
		Returns Purchase Prepaid Voucher BusinessTransactionType
	**/
    get CreatePrePaidVoucher(): IBusinessTransactionType {
        return this.FromId(57);
    }
    /**
		Returns Disburse Customer Funds BusinessTransactionType
	**/
    get DisburseCustomerFunds(): IBusinessTransactionType {
        return this.FromId(58);
    }
    /**
		Returns Accident Case BusinessTransactionType
	**/
    get AccidentCase(): IBusinessTransactionType {
        return this.FromId(59);
    }
    /**
		Returns Customer Chargeback BusinessTransactionType
	**/
    get CustomerChargeback(): IBusinessTransactionType {
        return this.FromId(60);
    }
    /**
		Returns Credential Renewal BusinessTransactionType
	**/
    get CredentialRenewal(): IBusinessTransactionType {
        return this.FromId(61);
    }
    /**
		Returns Credential Duplicate BusinessTransactionType
	**/
    get CredentialDuplicate(): IBusinessTransactionType {
        return this.FromId(62);
    }
    /**
		Returns ARMANI Conversion Transaction BusinessTransactionType
	**/
    get ARMANICONVERSIONTRANSACTION(): IBusinessTransactionType {
        return this.FromId(63);
    }
    /**
		Returns Request Registration Credit BusinessTransactionType
	**/
    get RequestRegistrationCredit(): IBusinessTransactionType {
        return this.FromId(64);
    }
    /**
		Returns Remote Test Instruction Permit BusinessTransactionType
	**/
    get RemoteTestInstructionPermit(): IBusinessTransactionType {
        return this.FromId(65);
    }
    /**
		Returns eTitle Transfer BusinessTransactionType
	**/
    get eTitleTransfer(): IBusinessTransactionType {
        return this.FromId(66);
    }
    /**
		Returns Release Lien BusinessTransactionType
	**/
    get ReleaseLien(): IBusinessTransactionType {
        return this.FromId(67);
    }
    /**
		Returns Compliance Payment BusinessTransactionType
	**/
    get CompliancePayment(): IBusinessTransactionType {
        return this.FromId(68);
    }
    /**
		Returns Vehicle MVR BusinessTransactionType
	**/
    get VehicleMVR(): IBusinessTransactionType {
        return this.FromId(69);
    }
    /**
		Returns Driver MVR BusinessTransactionType
	**/
    get DriverMVR(): IBusinessTransactionType {
        return this.FromId(70);
    }
    /**
		Returns Add or Release Lien BusinessTransactionType
	**/
    get AddReleaseLien(): IBusinessTransactionType {
        return this.FromId(71);
    }
    /**
		Returns Correct Lien BusinessTransactionType
	**/
    get CorrectLien(): IBusinessTransactionType {
        return this.FromId(72);
    }
    /**
		Returns Customer Digital Refund Request Reversal BusinessTransactionType
	**/
    get CustomerDigitalRefundRequestReversal(): IBusinessTransactionType {
        return this.FromId(73);
    }
    /**
		Returns Tab Replacement BusinessTransactionType
	**/
    get TabReplacement(): IBusinessTransactionType {
        return this.FromId(74);
    }
    /**
		Returns Modify Commercial Envelope Permit BusinessTransactionType
	**/
    get ModifyCommercialEnvelopePermit(): IBusinessTransactionType {
        return this.FromId(75);
    }
    /**
		Returns Miscellaneous Purchase BusinessTransactionType
	**/
    get MiscellaneousPurchase(): IBusinessTransactionType {
        return this.FromId(1065);
    }
    /**
		Returns Stand Alone Commercial Skill Test BusinessTransactionType
	**/
    get StandAloneCommercialSkillTest(): IBusinessTransactionType {
        return this.FromId(1066);
    }
    /**
		Returns Stand Alone Non Commercial Skill Test BusinessTransactionType
	**/
    get StandAloneNonCommercialSkillTest(): IBusinessTransactionType {
        return this.FromId(1067);
    }
    /**
		Returns Stand Alone Knowledge Test BusinessTransactionType
	**/
    get StandAloneKnowledgeTest(): IBusinessTransactionType {
        return this.FromId(1068);
    }
    /**
		Returns Stand Alone Vision Screening BusinessTransactionType
	**/
    get StandAloneVisionScreening(): IBusinessTransactionType {
        return this.FromId(1069);
    }
    /**
		Returns Stand Alone Motorcycle Skill Test BusinessTransactionType
	**/
    get StandAloneMotorcycleSkillTest(): IBusinessTransactionType {
        return this.FromId(1070);
    }
    /**
		Returns Stand Alone Add Remove Restrictions BusinessTransactionType
	**/
    get StandAloneAddRemoveRestrictions(): IBusinessTransactionType {
        return this.FromId(1071);
    }
    /**
		Returns Original FT Report Excise Tax BusinessTransactionType
	**/
    get OriginalFTReportExciseTax(): IBusinessTransactionType {
        return this.FromId(1072);
    }
    /**
		Returns Original FT Report UST Tax BusinessTransactionType
	**/
    get OriginalFTReportUSTTax(): IBusinessTransactionType {
        return this.FromId(1073);
    }
    /**
		Returns Amended FT Report Excise Tax  BusinessTransactionType
	**/
    get AmendedFTReportExciseTax(): IBusinessTransactionType {
        return this.FromId(1074);
    }
    /**
		Returns Amended FT Report Excise Tax CR BusinessTransactionType
	**/
    get AmendedFTReportExciseTaxCR(): IBusinessTransactionType {
        return this.FromId(1075);
    }
    /**
		Returns Amended FT Report UST Tax BusinessTransactionType
	**/
    get AmendedFTReportUSTTax(): IBusinessTransactionType {
        return this.FromId(1076);
    }
    /**
		Returns UST Tax Credit BusinessTransactionType
	**/
    get USTTaxCredit(): IBusinessTransactionType {
        return this.FromId(1077);
    }
    /**
		Returns Excise Tax Penalties and Interest BusinessTransactionType
	**/
    get ExciseTaxPenaltyInterest(): IBusinessTransactionType {
        return this.FromId(1078);
    }
    /**
		Returns UST Tax Penalties and Interest BusinessTransactionType
	**/
    get USTTaxPenaltyInterest(): IBusinessTransactionType {
        return this.FromId(1079);
    }
    /**
		Returns Cancel Temporary Registration Plate (TRP) BusinessTransactionType
	**/
    get CancelTRP(): IBusinessTransactionType {
        return this.FromId(1080);
    }
    /**
		Returns Excise Tax Credit BusinessTransactionType
	**/
    get ExciseTaxCredit(): IBusinessTransactionType {
        return this.FromId(1081);
    }
    /**
		Returns Fund Charitable Organization BusinessTransactionType
	**/
    get FundCharitableOrganization(): IBusinessTransactionType {
        return this.FromId(1082);
    }
    /**
		Returns Audit Assessment Excise Tax BusinessTransactionType
	**/
    get AuditAssessmentExciseTax(): IBusinessTransactionType {
        return this.FromId(1083);
    }
    /**
		Returns Notice of Assessment Excise Tax BusinessTransactionType
	**/
    get NoticeofAssessmentExciseTax(): IBusinessTransactionType {
        return this.FromId(1084);
    }
    /**
		Returns Fuel Tax Adjustment Excise Tax BusinessTransactionType
	**/
    get FuelTaxAdjustmentExciseTax(): IBusinessTransactionType {
        return this.FromId(1085);
    }
    /**
		Returns Audit Assessment UST BusinessTransactionType
	**/
    get AuditAssessmentUST(): IBusinessTransactionType {
        return this.FromId(1086);
    }
    /**
		Returns Notice of Assessment UST BusinessTransactionType
	**/
    get NoticeofAssessmentUST(): IBusinessTransactionType {
        return this.FromId(1087);
    }
    /**
		Returns Fuel Tax Adjustment UST BusinessTransactionType
	**/
    get FuelTaxAdjustmentUST(): IBusinessTransactionType {
        return this.FromId(1088);
    }
    /**
		Returns FT Fund Customer Account BusinessTransactionType
	**/
    get FTFundCustomerAccount(): IBusinessTransactionType {
        return this.FromId(1089);
    }
    /**
		Returns Conversion - AADA BusinessTransactionType
	**/
    get ConversionAADA(): IBusinessTransactionType {
        return this.FromId(1090);
    }
    /**
		Returns Conversion - AQF BusinessTransactionType
	**/
    get ConversionAQF(): IBusinessTransactionType {
        return this.FromId(1091);
    }
    /**
		Returns Conversion - Aviation BusinessTransactionType
	**/
    get ConversionAviation(): IBusinessTransactionType {
        return this.FromId(1092);
    }
    /**
		Returns Conversion - DCK BusinessTransactionType
	**/
    get ConversionDCK(): IBusinessTransactionType {
        return this.FromId(1093);
    }
    /**
		Returns Conversion - Dealer BusinessTransactionType
	**/
    get ConversionDealer(): IBusinessTransactionType {
        return this.FromId(1094);
    }
    /**
		Returns Conversion - Driver License BusinessTransactionType
	**/
    get ConversionDriverLicense(): IBusinessTransactionType {
        return this.FromId(1095);
    }
    /**
		Returns Conversion - Game and Fish BusinessTransactionType
	**/
    get ConversionGameAndFish(): IBusinessTransactionType {
        return this.FromId(1096);
    }
    /**
		Returns Conversion - IRP BusinessTransactionType
	**/
    get ConversionIRP(): IBusinessTransactionType {
        return this.FromId(1097);
    }
    /**
		Returns Conversion - MCarrier BusinessTransactionType
	**/
    get ConversionMCarrier(): IBusinessTransactionType {
        return this.FromId(1098);
    }
    /**
		Returns Conversion - Miscellaneous Transaction BusinessTransactionType
	**/
    get ConversionMiscellaneousTransaction(): IBusinessTransactionType {
        return this.FromId(1099);
    }
    /**
		Returns Conversion - Motor Carrier BusinessTransactionType
	**/
    get ConversionMotorCarrier(): IBusinessTransactionType {
        return this.FromId(1100);
    }
    /**
		Returns Conversion - PPV Payment BusinessTransactionType
	**/
    get ConversionPPVPayment(): IBusinessTransactionType {
        return this.FromId(1101);
    }
    /**
		Returns Conversion - Registration BusinessTransactionType
	**/
    get ConversionRegistration(): IBusinessTransactionType {
        return this.FromId(1102);
    }
    /**
		Returns Conversion - Transport BusinessTransactionType
	**/
    get ConversionTransport(): IBusinessTransactionType {
        return this.FromId(1103);
    }
    /**
		Returns Conversion - Weights And Permits BusinessTransactionType
	**/
    get ConversionWeightsAndPermits(): IBusinessTransactionType {
        return this.FromId(1104);
    }
    /**
		Returns Enforcement Transactions BusinessTransactionType
	**/
    get EnforcementTransactions(): IBusinessTransactionType {
        return this.FromId(1105);
    }
    /**
		Returns POE Transactions BusinessTransactionType
	**/
    get POETransactions(): IBusinessTransactionType {
        return this.FromId(1106);
    }
    /**
		Returns Mobile Unit Transactions BusinessTransactionType
	**/
    get MobileUnitTransactions(): IBusinessTransactionType {
        return this.FromId(1107);
    }
    /**
		Returns Tech Support Transactions BusinessTransactionType
	**/
    get TechSupportTransactions(): IBusinessTransactionType {
        return this.FromId(1108);
    }
    /**
		Returns Permit Transactions BusinessTransactionType
	**/
    get PermitTransactions(): IBusinessTransactionType {
        return this.FromId(1109);
    }
    /**
		Returns Inspection Transactions BusinessTransactionType
	**/
    get InspectionTransactions(): IBusinessTransactionType {
        return this.FromId(1110);
    }
    /**
		Returns County Miscellaneous Purchase BusinessTransactionType
	**/
    get CountyMiscellaneousPurchase(): IBusinessTransactionType {
        return this.FromId(1111);
    }
    /**
		Returns Audit Assessment Excise Tax Penalties and Interest BusinessTransactionType
	**/
    get AuditAssessmentExcisePenaltiesInterest(): IBusinessTransactionType {
        return this.FromId(1112);
    }
    /**
		Returns Notice of Assessment Excise Tax Penalties and Interest BusinessTransactionType
	**/
    get NoticeofAssessmentExciseTaxPenaltiesInterest(): IBusinessTransactionType {
        return this.FromId(1113);
    }
    /**
		Returns Fuel Tax Adjustment Excise Tax Penalties and Interest BusinessTransactionType
	**/
    get FuelTaxAdjustmentExciseTaxPenaltiesInterest(): IBusinessTransactionType {
        return this.FromId(1114);
    }
    /**
		Returns Fuel Tax Adjustment UST Penalties and Interest BusinessTransactionType
	**/
    get FuelTaxAdjustmentUSTPenaltiesInterest(): IBusinessTransactionType {
        return this.FromId(1115);
    }
    /**
		Returns Audit Assessment UST Penalties and Interest BusinessTransactionType
	**/
    get AuditAssessmentUSTPenaltiesInterest(): IBusinessTransactionType {
        return this.FromId(1116);
    }
    /**
		Returns Notice of Assessment UST Penalties and Interest BusinessTransactionType
	**/
    get NoticeofAssessmentUSTPenaltiesInterest(): IBusinessTransactionType {
        return this.FromId(1117);
    }
    /**
		Returns Audit Assessment Excise Tax Credit BusinessTransactionType
	**/
    get AuditAssessmentExciseTaxCredit(): IBusinessTransactionType {
        return this.FromId(1118);
    }
    /**
		Returns Notice of Assessment Excise Tax Credit BusinessTransactionType
	**/
    get NoticeofAssessmentExciseTaxCredit(): IBusinessTransactionType {
        return this.FromId(1119);
    }
    /**
		Returns Fuel Tax Adjustment Excise Tax Credit BusinessTransactionType
	**/
    get FuelTaxAdjustmentExciseTaxCredit(): IBusinessTransactionType {
        return this.FromId(1120);
    }
    /**
		Returns Fuel Tax Adjustment UST Credit BusinessTransactionType
	**/
    get FuelTaxAdjustmentUSTCredit(): IBusinessTransactionType {
        return this.FromId(1121);
    }
    /**
		Returns Audit Assessment UST Credit BusinessTransactionType
	**/
    get AuditAssessmentUSTCredit(): IBusinessTransactionType {
        return this.FromId(1122);
    }
    /**
		Returns Notice of Assessment UST Credit BusinessTransactionType
	**/
    get NoticeofAssessmentUSTCredit(): IBusinessTransactionType {
        return this.FromId(1123);
    }
    /**
		Returns TnR Corrections Old BusinessTransactionType
	**/
    get TnRCorrections(): IBusinessTransactionType {
        return this.FromId(1124);
    }
    /**
		Returns TnR Recreate BusinessTransactionType
	**/
    get TnRRecreate(): IBusinessTransactionType {
        return this.FromId(1125);
    }
    /**
		Returns Cancel Credential BusinessTransactionType
	**/
    get CancelCredential(): IBusinessTransactionType {
        return this.FromId(1126);
    }
    /**
		Returns Recreate TRP BusinessTransactionType
	**/
    get RecreateTRP(): IBusinessTransactionType {
        return this.FromId(1133);
    }
    /**
		Returns Duplicate Plate BusinessTransactionType
	**/
    get DuplicatePlate(): IBusinessTransactionType {
        return this.FromId(1134);
    }
    /**
		Returns Transfer Customer Account BusinessTransactionType
	**/
    get TransferCustomerAccount(): IBusinessTransactionType {
        return this.FromId(1135);
    }
    /**
		Returns TnR Corrections BusinessTransactionType
	**/
    get Correction(): IBusinessTransactionType {
        return this.FromId(1137);
    }
    /**
		Returns Fuel Tax Adjustment Excise Tax ACH Return BusinessTransactionType
	**/
    get FuelTaxAdjustmentExciseTaxACHReturn(): IBusinessTransactionType {
        return this.FromId(1139);
    }
    /**
		Returns Fuel Tax Adjustment UST ACH Return BusinessTransactionType
	**/
    get FuelTaxAdjustmentUSTACHReturn(): IBusinessTransactionType {
        return this.FromId(1140);
    }
    /**
		Returns Fuel Tax Adjustment Excise ACH Return Tax Credit BusinessTransactionType
	**/
    get FuelTaxAdjustmentExciseACHReturnTaxCredit(): IBusinessTransactionType {
        return this.FromId(1141);
    }
    /**
		Returns Fuel Tax Adjustment UST ACH Return Tax Credit BusinessTransactionType
	**/
    get FuelTaxAdjustmentUSTACHReturnTaxCredit(): IBusinessTransactionType {
        return this.FromId(1142);
    }
    /**
		Returns Motor Carrier Edit Account BusinessTransactionType
	**/
    get MCAChangeName(): IBusinessTransactionType {
        return this.FromId(1143);
    }
    /**
		Returns Motor Carrier Straight Fleet Renewal BusinessTransactionType
	**/
    get MCAStraightRenewal(): IBusinessTransactionType {
        return this.FromId(1144);
    }
    /**
		Returns Create IFTA Account BusinessTransactionType
	**/
    get MCACreateIFTA(): IBusinessTransactionType {
        return this.FromId(1145);
    }
    /**
		Returns MVD Clearing Account Adjustment BusinessTransactionType
	**/
    get MVDClearingAccountAdjustment(): IBusinessTransactionType {
        return this.FromId(1146);
    }
    /**
		Returns Commercial Permit BusinessTransactionType
	**/
    get CommercialPermit(): IBusinessTransactionType {
        return this.FromId(1147);
    }
    /**
		Returns Motor Carrier Delete Vehicle BusinessTransactionType
	**/
    get MCADeleteVehicle(): IBusinessTransactionType {
        return this.FromId(1148);
    }
    /**
		Returns Motor Carrier Add Vehicle BusinessTransactionType
	**/
    get MCAAddVehicle(): IBusinessTransactionType {
        return this.FromId(1149);
    }
    /**
		Returns Motor Carrier Fleet Renewal BusinessTransactionType
	**/
    get MCARenewFleet(): IBusinessTransactionType {
        return this.FromId(1150);
    }
    /**
		Returns Motor Carrier Add Vehicle with Transfer BusinessTransactionType
	**/
    get MCAAddVehicleTransfer(): IBusinessTransactionType {
        return this.FromId(1151);
    }
    /**
		Returns Motor Carrier Replace Plate BusinessTransactionType
	**/
    get MCAReplacePlate(): IBusinessTransactionType {
        return this.FromId(1152);
    }
    /**
		Returns Motor Carrier Cab Card Correction BusinessTransactionType
	**/
    get MCACabCardCorrection(): IBusinessTransactionType {
        return this.FromId(1153);
    }
    /**
		Returns Motor Carrier Amend Vehicle BusinessTransactionType
	**/
    get MCADAmendVehicle(): IBusinessTransactionType {
        return this.FromId(1154);
    }
    /**
		Returns Motor Carrier Change Fleet Type BusinessTransactionType
	**/
    get MCAChangeFleetType(): IBusinessTransactionType {
        return this.FromId(1155);
    }
    /**
		Returns Cancel Commercial Permit BusinessTransactionType
	**/
    get CancelCommercialPermit(): IBusinessTransactionType {
        return this.FromId(1156);
    }
    /**
		Returns Modify Commercial Permit BusinessTransactionType
	**/
    get ModifyCommercialPermit(): IBusinessTransactionType {
        return this.FromId(1158);
    }
    /**
		Returns Motor Carrier Replace IFTA Decals BusinessTransactionType
	**/
    get MCAReplaceDecals(): IBusinessTransactionType {
        return this.FromId(1165);
    }
    /**
		Returns Dealer Off Premise Permit BusinessTransactionType
	**/
    get DealerOffPremisePermit(): IBusinessTransactionType {
        return this.FromId(1169);
    }
    /**
		Returns Dealer License Renewal BusinessTransactionType
	**/
    get DealerLicenseRenewal(): IBusinessTransactionType {
        return this.FromId(1173);
    }
    /**
		Returns Motor Carrier Grow Up TPA BusinessTransactionType
	**/
    get MCAGrowUpTPA(): IBusinessTransactionType {
        return this.FromId(1175);
    }
    /**
		Returns IFTA Add Bond BusinessTransactionType
	**/
    get MCIFTAAddBond(): IBusinessTransactionType {
        return this.FromId(1176);
    }
    /**
		Returns IFTA Update Bond BusinessTransactionType
	**/
    get MCIFTAUpdateBond(): IBusinessTransactionType {
        return this.FromId(1177);
    }
    /**
		Returns IFTA Release Bond BusinessTransactionType
	**/
    get MCIFTAReleaseBond(): IBusinessTransactionType {
        return this.FromId(1178);
    }
    /**
		Returns Reverse Compliance Payment BusinessTransactionType
	**/
    get ReverseCompliancePayment(): IBusinessTransactionType {
        return this.FromId(1180);
    }
    /**
		Returns Motor Carrier Audit BusinessTransactionType
	**/
    get MCAudit(): IBusinessTransactionType {
        return this.FromId(1181);
    }
    /**
		Returns Add Aircraft Registration BusinessTransactionType
	**/
    get AddAircraftRegistration(): IBusinessTransactionType {
        return this.FromId(1182);
    }
    /**
		Returns Update Aircraft Registration BusinessTransactionType
	**/
    get UpdAircraftRegistration(): IBusinessTransactionType {
        return this.FromId(1183);
    }
    /**
		Returns Change Aircraft Ownership BusinessTransactionType
	**/
    get ChgAircraftOwnership(): IBusinessTransactionType {
        return this.FromId(1184);
    }
    /**
		Returns Pay Aircraft Invoice BusinessTransactionType
	**/
    get PayAircraftInvoice(): IBusinessTransactionType {
        return this.FromId(1185);
    }
    /**
		Returns Penalty Aircraft BusinessTransactionType
	**/
    get PenaltyAircraft(): IBusinessTransactionType {
        return this.FromId(1186);
    }
    /**
		Returns Aircraft Assessment BusinessTransactionType
	**/
    get AircraftAssessment(): IBusinessTransactionType {
        return this.FromId(1187);
    }
    /**
		Returns Reactivate Aircraft Registration BusinessTransactionType
	**/
    get ReactivateAircraftRegistration(): IBusinessTransactionType {
        return this.FromId(1188);
    }
    /**
		Returns Void Supplement BusinessTransactionType
	**/
    get VoidSupplement(): IBusinessTransactionType {
        return this.FromId(1189);
    }
    /**
		Returns Motor Carrier Vehicle Maintenance BusinessTransactionType
	**/
    get MCAVehicleMaintenance(): IBusinessTransactionType {
        return this.FromId(1190);
    }
    /**
		Returns Motor Carrier Vehicle Correction BusinessTransactionType
	**/
    get MCAVehicleCorrection(): IBusinessTransactionType {
        return this.FromId(1191);
    }
    /**
		Returns Vehicle Inspection BusinessTransactionType
	**/
    get VehicleInspection(): IBusinessTransactionType {
        return this.FromId(1192);
    }
    /**
		Returns Void Cancel Registration BusinessTransactionType
	**/
    get VoidCancelRegistration(): IBusinessTransactionType {
        return this.FromId(1193);
    }
    /**
		Returns Stand Alone Voter Registration BusinessTransactionType
	**/
    get StandAloneVoterRegistration(): IBusinessTransactionType {
        return this.FromId(1194);
    }
    /**
       Returns Stand Alone Voter Registration BusinessTransactionType
   **/
    get MCAMaintainIFTALicense(): IBusinessTransactionType {
        return this.FromId(1195);
    }
    /**
        Returns Reversions ARS 28-364(E)(2) BusinessTransactionType
    **/
    get UnusedBalanceTransfer(): IBusinessTransactionType {
        return this.FromId(1198);
    }
    /**
        Returns Unclaimed ARS 28-5725 (A) BusinessTransactionType
    **/
    get IFTAUnclaimedProperty(): IBusinessTransactionType {
        return this.FromId(1199);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1127', { id: 1127, businessTransactionCategoryTypeId: 3, value: 'AuditAssessmentExcisePenaltiesInterestTaxCredit', displayValue: 'Audit Assessment Excise Penalties Interest Tax Credit', description: 'Audit Assessment Excise Penalties Interest Tax Credit', sortOrder: 99999, active: true });
        this._dictionary.add('1128', { id: 1128, businessTransactionCategoryTypeId: 3, value: 'NoticeofAssessmentExcisePenaltiesInterestTaxCredit', displayValue: 'Notice of Assessment Excise Penalties Interest Tax Credit', description: 'Notice of Assessment Excise Penalties Interest Tax Credit', sortOrder: 99999, active: true });
        this._dictionary.add('1129', { id: 1129, businessTransactionCategoryTypeId: 3, value: 'FuelTaxAdjustmentExcisePenaltiesInterestTaxCredit', displayValue: 'Fuel Tax Adjustment Excise Penalties Interest Tax Credit', description: 'Fuel Tax Adjustment Excise Penalties Interest Tax Credit', sortOrder: 99999, active: true });
        this._dictionary.add('1130', { id: 1130, businessTransactionCategoryTypeId: 3, value: 'FuelTaxAdjustmentUSTPenaltiesInterestTaxCredit', displayValue: 'Fuel Tax Adjustment UST Penalties Interest Tax Credit', description: 'Fuel Tax Adjustment UST Penalties Interest Tax Credit', sortOrder: 99999, active: true });
        this._dictionary.add('1131', { id: 1131, businessTransactionCategoryTypeId: 3, value: 'AuditAssessmentUSTPenaltiesInterestTaxCredit', displayValue: 'Audit Assessment UST Penalties Interest Tax Credit', description: 'Audit Assessment UST Penalties Interest Tax Credit', sortOrder: 99999, active: true });
        this._dictionary.add('1132', { id: 1132, businessTransactionCategoryTypeId: 3, value: 'NoticeofAssessmentUSTPenaltiesInterestTaxCredit', displayValue: 'Notice of Assessment UST Penalties Interest Tax Credit', description: 'Notice of Assessment UST Penalties Interest Tax Credit', sortOrder: 99999, active: true });
        this._dictionary.add('1136', { id: 1136, businessTransactionCategoryTypeId: 1, value: 'MiscellaneousReversal', displayValue: 'Miscellaneous Refund', description: 'Miscellaneous Refund', sortOrder: 99999, active: true });
        this._dictionary.add('1138', { id: 1138, businessTransactionCategoryTypeId: 1, value: 'CollectionsPayment', displayValue: 'Collections Payment', description: 'Collections Payment', sortOrder: 99999, active: true });
        this._dictionary.add('1157', { id: 1157, businessTransactionCategoryTypeId: 1, value: 'MCAReplaceCabCard', displayValue: 'Motor Carrier Replace Cab Card', description: 'Motor Carrier Replace Cab Card', sortOrder: 99999, active: true });
        this._dictionary.add('1159', { id: 1159, businessTransactionCategoryTypeId: 1, value: 'MCAFileQuarterlyReportIFTA', displayValue: 'Motor Carrier File Quarterly Report IFTA', description: 'Motor Carrier File Quarterly Report IFTA', sortOrder: 99999, active: true });
        this._dictionary.add('1160', { id: 1160, businessTransactionCategoryTypeId: 1, value: 'MCAAddDecalsIFTA', displayValue: 'Motor Carrier Add Decals IFTA', description: 'Motor Carrier Add Decals IFTA', sortOrder: 99999, active: true });
        this._dictionary.add('1161', { id: 1161, businessTransactionCategoryTypeId: 1, value: 'MCAAmendQuarterlyReportIFTA', displayValue: 'Motor Carrier Amend Quarterly Report IFTA', description: 'Motor Carrier Amend Quarterly Report IFTA', sortOrder: 99999, active: true });
        this._dictionary.add('1162', { id: 1162, businessTransactionCategoryTypeId: 1, value: 'MCADuplicateIFTALicense', displayValue: 'Motor Carrier Duplicate IFTA License', description: 'Motor Carrier Duplicate IFTA License', sortOrder: 99999, active: true });
        this._dictionary.add('1163', { id: 1163, businessTransactionCategoryTypeId: 1, value: 'MCARenewIFTALicense', displayValue: 'Motor Carrier Renew IFTA License', description: 'Motor Carrier Renew IFTA License', sortOrder: 99999, active: true });
        this._dictionary.add('1164', { id: 1164, businessTransactionCategoryTypeId: 1, value: 'MCAErrorCorrection', displayValue: 'Motor Carrier Error Correction', description: 'Motor Carrier Error Correction', sortOrder: 99999, active: true });
        this._dictionary.add('1166', { id: 1166, businessTransactionCategoryTypeId: 1, value: 'MCAErrorCorrectionMileage', displayValue: 'Motor Carrier Error Correction- Mileage', description: 'Motor Carrier Error Correction- Mileage', sortOrder: 99999, active: true });
        this._dictionary.add('1167', { id: 1167, businessTransactionCategoryTypeId: 1, value: 'MCAErrorCorrectionDeleteVehicle', displayValue: 'Motor Carrier Error Correction- Delete Vehicle', description: 'Motor Carrier Error Correction- Delete Vehicle', sortOrder: 99999, active: true });
        this._dictionary.add('1170', { id: 1170, businessTransactionCategoryTypeId: 1, value: 'CharitableEventTRP', displayValue: 'Charitable Event TRP', description: 'Charitable Event TRP', sortOrder: 99999, active: true });
        this._dictionary.add('1174', { id: 1174, businessTransactionCategoryTypeId: 3, value: 'RefundCommercialPermit', displayValue: 'Refund Commercial Permit', description: 'Refund Commercial Permit', sortOrder: 99999, active: true });
        this._dictionary.add('1179', { id: 1179, businessTransactionCategoryTypeId: 1, value: 'DealerPublicConsignmentSalesNotice', displayValue: 'DSPC Sold Notice', description: 'Dealer Suite Public Consignment Sales Notice', sortOrder: 99999, active: true });
        this._dictionary.add('1', { id: 1, businessTransactionCategoryTypeId: 1, value: 'TitleOnly', displayValue: 'Title Only', description: 'Title Only', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, businessTransactionCategoryTypeId: 1, value: 'RegistrationOnly', displayValue: 'Registration Only', description: 'Registration Only', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, businessTransactionCategoryTypeId: 1, value: 'TitleandRegistration', displayValue: 'Title and Registration', description: 'Title and Registration', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, businessTransactionCategoryTypeId: 1, value: 'CommercialEnvelopePermit', displayValue: 'Commercial Envelope Permit', description: 'Commercial Envelope Permit', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, businessTransactionCategoryTypeId: 1, value: 'IssueTemporaryPlacard', displayValue: 'Issue Temporary Placard', description: 'Issue Temporary Placard', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, businessTransactionCategoryTypeId: 1, value: 'ReplaceTemporaryPlacard', displayValue: 'Replace Temporary Placard', description: 'Replace Temporary Placard', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, businessTransactionCategoryTypeId: 1, value: 'RenewPermanentPlacard', displayValue: 'Renew Permanent Placard', description: 'Renew Permanent Placard', sortOrder: 999999, active: false });
        this._dictionary.add('8', { id: 8, businessTransactionCategoryTypeId: 1, value: 'CancelTemporaryPlacard', displayValue: 'Cancel Temporary Placard', description: 'Cancel Temporary Placard', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, businessTransactionCategoryTypeId: 1, value: 'IssuePermanentPlacard', displayValue: 'Issue Permanent Placard', description: 'Issue Permanent Placard', sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, businessTransactionCategoryTypeId: 1, value: 'ReplacePermanentPlacard', displayValue: 'Replace Permanent Placard', description: 'Replace Permanent Placard', sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, businessTransactionCategoryTypeId: 1, value: 'CancelPermanentPlacard', displayValue: 'Cancel Permanent Placard', description: 'Cancel Permanent Placard', sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, businessTransactionCategoryTypeId: 1, value: 'IssuePermit', displayValue: 'Issue Permit', description: 'Issue Permit', sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, businessTransactionCategoryTypeId: 1, value: 'ReprintPermit', displayValue: 'Reprint Permit', description: 'Reprint Permit', sortOrder: 999999, active: false });
        this._dictionary.add('14', { id: 14, businessTransactionCategoryTypeId: 1, value: 'CancelPermit', displayValue: 'Cancel Permit', description: 'Cancel Permit', sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, businessTransactionCategoryTypeId: 1, value: 'PrintTitle', displayValue: 'Print Title', description: 'Print Title', sortOrder: 999999, active: true });
        this._dictionary.add('16', { id: 16, businessTransactionCategoryTypeId: 1, value: 'ManageLiensandBrands', displayValue: 'Manage Liens and Brands', description: 'Manage Liens and Brands', sortOrder: 999999, active: true });
        this._dictionary.add('17', { id: 17, businessTransactionCategoryTypeId: 1, value: 'CancelTitle', displayValue: 'Cancel Title', description: 'Cancel Title', sortOrder: 999999, active: true });
        this._dictionary.add('18', { id: 18, businessTransactionCategoryTypeId: 1, value: 'RenewRegistration', displayValue: 'Renew Registration', description: 'Renew Registration', sortOrder: 999999, active: true });
        this._dictionary.add('19', { id: 19, businessTransactionCategoryTypeId: 1, value: 'DuplicateRegistration', displayValue: 'Duplicate Registration', description: 'Duplicate Registration', sortOrder: 999999, active: false });
        this._dictionary.add('20', { id: 20, businessTransactionCategoryTypeId: 1, value: 'UpdateRegistration', displayValue: 'Update Registration', description: 'Update Registration', sortOrder: 999999, active: true });
        this._dictionary.add('21', { id: 21, businessTransactionCategoryTypeId: 1, value: 'SuspendRegistration', displayValue: 'Suspend Registration', description: 'Suspend Registration', sortOrder: 999999, active: true });
        this._dictionary.add('22', { id: 22, businessTransactionCategoryTypeId: 1, value: 'AddInsurance', displayValue: 'Add Insurance', description: 'Add Insurance', sortOrder: 999999, active: false });
        this._dictionary.add('23', { id: 23, businessTransactionCategoryTypeId: 1, value: 'UpdateInsurance', displayValue: 'Update Insurance', description: 'Update Insurance', sortOrder: 999999, active: false });
        this._dictionary.add('24', { id: 24, businessTransactionCategoryTypeId: 1, value: 'AbandonedVehicle', displayValue: 'Abandoned Vehicle', description: 'Abandoned Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('25', { id: 25, businessTransactionCategoryTypeId: 1, value: 'SoldNotice', displayValue: 'Sold Notice', description: 'Sold Notice', sortOrder: 999999, active: false });
        this._dictionary.add('26', { id: 26, businessTransactionCategoryTypeId: 1, value: 'RemoveSoldNotice', displayValue: 'Remove Sold Notice', description: 'Remove Sold Notice', sortOrder: 999999, active: false });
        this._dictionary.add('27', { id: 27, businessTransactionCategoryTypeId: 1, value: 'AddBrand', displayValue: 'Add Brand', description: 'Add Brand', sortOrder: 999999, active: false });
        this._dictionary.add('28', { id: 28, businessTransactionCategoryTypeId: 1, value: 'MaintainBrand', displayValue: 'Maintain Brand', description: 'Maintain Brand', sortOrder: 999999, active: false });
        this._dictionary.add('29', { id: 29, businessTransactionCategoryTypeId: 1, value: 'Checkout', displayValue: 'Checkout', description: 'Checkout', sortOrder: 999999, active: false });
        this._dictionary.add('30', { id: 30, businessTransactionCategoryTypeId: 1, value: 'ReceiptManagement', displayValue: 'Receipt Management', description: 'Receipt Management', sortOrder: 999999, active: false });
        this._dictionary.add('31', { id: 31, businessTransactionCategoryTypeId: 1, value: 'LECUAuditReport', displayValue: 'LECU Audit Report', description: 'LECU Audit Report', sortOrder: 999999, active: true });
        this._dictionary.add('32', { id: 32, businessTransactionCategoryTypeId: 1, value: 'IAAuditReport', displayValue: 'IA Audit Report', description: 'IA Audit Report', sortOrder: 999999, active: true });
        this._dictionary.add('33', { id: 33, businessTransactionCategoryTypeId: 1, value: 'ReinstateRegistration', displayValue: 'Reinstate Registration', description: 'Reinstate Registration', sortOrder: 999999, active: true });
        this._dictionary.add('34', { id: 34, businessTransactionCategoryTypeId: 1, value: 'VoidRegistration', displayValue: 'Void Registration', description: 'Void Registration', sortOrder: 999999, active: true });
        this._dictionary.add('35', { id: 35, businessTransactionCategoryTypeId: 1, value: 'VoidTitle', displayValue: 'Void Title', description: 'Void Title', sortOrder: 999999, active: true });
        this._dictionary.add('36', { id: 36, businessTransactionCategoryTypeId: 1, value: 'VoidTitleandRegistration', displayValue: 'Void Title and Registration', description: 'Void Title and Registration', sortOrder: 999999, active: true });
        this._dictionary.add('37', { id: 37, businessTransactionCategoryTypeId: 1, value: 'RevokeRegistration', displayValue: 'Revoke Registration', description: 'Revoke Registration', sortOrder: 999999, active: true });
        this._dictionary.add('38', { id: 38, businessTransactionCategoryTypeId: 1, value: 'CredentialIssuance', displayValue: 'Credential Issuance', description: 'Credential Issuance', sortOrder: 999999, active: true });
        this._dictionary.add('39', { id: 39, businessTransactionCategoryTypeId: 1, value: 'MVMRefund', displayValue: 'MVM Refund', description: 'MVM Refund', sortOrder: 999999, active: true });
        this._dictionary.add('40', { id: 40, businessTransactionCategoryTypeId: 1, value: 'IssueGFDecal', displayValue: 'Issue GF Decal', description: 'Issue Game and Fish Decal', sortOrder: 999999, active: false });
        this._dictionary.add('41', { id: 41, businessTransactionCategoryTypeId: 1, value: 'ReplaceGFDecal', displayValue: 'Replace OHV Decal', description: 'Replace Off Highway Decal', sortOrder: 999999, active: true });
        this._dictionary.add('42', { id: 42, businessTransactionCategoryTypeId: 1, value: 'RenewOHVDecal', displayValue: 'Renew OHV Decal', description: 'Renew Off Highway Decal', sortOrder: 999999, active: true });
        this._dictionary.add('43', { id: 43, businessTransactionCategoryTypeId: 1, value: 'ABVReport(E-Crushed)', displayValue: 'ABV Report (E-Crushed)', description: 'ABV Report (E-Crushed)', sortOrder: 999999, active: true });
        this._dictionary.add('44', { id: 44, businessTransactionCategoryTypeId: 1, value: 'ABVReport(E-Request)', displayValue: 'ABV Report (E-Request)', description: 'ABV Report (E-Request)', sortOrder: 999999, active: true });
        this._dictionary.add('45', { id: 45, businessTransactionCategoryTypeId: 1, value: 'TitleMobileHome', displayValue: 'Title Mobile Home', description: 'Title Mobile Home', sortOrder: 999999, active: false });
        this._dictionary.add('46', { id: 46, businessTransactionCategoryTypeId: 1, value: 'EZLienholderMVR', displayValue: 'EZ Lienholder MVR', description: 'EZ Lienholder MVR', sortOrder: 999999, active: false });
        this._dictionary.add('47', { id: 47, businessTransactionCategoryTypeId: 1, value: 'VoidPermit', displayValue: 'Void Permit', description: 'Void Permit', sortOrder: 999999, active: true });
        this._dictionary.add('48', { id: 48, businessTransactionCategoryTypeId: 1, value: 'DuplicateMobileHomeTitle', displayValue: 'Duplicate Mobile Home Title', description: 'Duplicate Mobile Home Title', sortOrder: 999999, active: false });
        this._dictionary.add('49', { id: 49, businessTransactionCategoryTypeId: 1, value: 'ReserveSpecialPlate', displayValue: 'Reserve Special Plate', description: 'Reserve Special Plate', sortOrder: 999999, active: true });
        this._dictionary.add('50', { id: 50, businessTransactionCategoryTypeId: 1, value: 'IssueTRP', displayValue: 'Temporary Registration Plate', description: 'Temporary Registration Plate', sortOrder: 999999, active: true });
        this._dictionary.add('51', { id: 51, businessTransactionCategoryTypeId: 1, value: 'HomemadeVehiclePermit', displayValue: 'Homemade Vehicle Permit', description: 'Homemade Vehicle Permit', sortOrder: 999999, active: true });
        this._dictionary.add('52', { id: 52, businessTransactionCategoryTypeId: 1, value: 'CancelRegistration', displayValue: 'Cancel Registration', description: 'Cancel Registration', sortOrder: 999999, active: true });
        this._dictionary.add('53', { id: 53, businessTransactionCategoryTypeId: 1, value: 'MiscellaneousTransaction', displayValue: 'Miscellaneous Transaction', description: 'Miscellaneous Transaction', sortOrder: 999999, active: true });
        this._dictionary.add('54', { id: 54, businessTransactionCategoryTypeId: 3, value: 'MiscellaneousTransactionRefund', displayValue: 'Miscellaneous Transaction Refund', description: 'Miscellaneous Transaction Refund', sortOrder: 999999, active: true });
        this._dictionary.add('55', { id: 55, businessTransactionCategoryTypeId: 1, value: 'MotorCarrier', displayValue: 'Motor Carrier', description: 'Motor Carrier', sortOrder: 999999, active: true });
        this._dictionary.add('56', { id: 56, businessTransactionCategoryTypeId: 1, value: 'FundCustomerAccount', displayValue: 'Fund Customer Account', description: 'Fund Customer Account', sortOrder: 999999, active: true });
        this._dictionary.add('57', { id: 57, businessTransactionCategoryTypeId: 1, value: 'CreatePrePaidVoucher', displayValue: 'Purchase Prepaid Voucher', description: 'Purchase Prepaid Voucher', sortOrder: 999999, active: true });
        this._dictionary.add('58', { id: 58, businessTransactionCategoryTypeId: 3, value: 'DisburseCustomerFunds', displayValue: 'Disburse Customer Funds', description: 'Disburse Customer Funds', sortOrder: 999999, active: true });
        this._dictionary.add('59', { id: 59, businessTransactionCategoryTypeId: 1, value: 'AccidentCase', displayValue: 'Accident Case', description: 'Accident Case', sortOrder: 999999, active: true });
        this._dictionary.add('60', { id: 60, businessTransactionCategoryTypeId: 4, value: 'CustomerChargeback', displayValue: 'Customer Chargeback', description: 'Customer Chargeback', sortOrder: 999999, active: true });
        this._dictionary.add('61', { id: 61, businessTransactionCategoryTypeId: 1, value: 'CredentialRenewal', displayValue: 'Credential Renewal', description: 'Credential Renewal', sortOrder: 999999, active: true });
        this._dictionary.add('62', { id: 62, businessTransactionCategoryTypeId: 1, value: 'CredentialDuplicate', displayValue: 'Credential Duplicate', description: 'Credential Duplicate', sortOrder: 999999, active: true });
        this._dictionary.add('63', { id: 63, businessTransactionCategoryTypeId: 1, value: 'ARMANICONVERSIONTRANSACTION', displayValue: 'ARMANI Conversion Transaction', description: 'ARMANI Conversion Transaction', sortOrder: 999999, active: true });
        this._dictionary.add('64', { id: 64, businessTransactionCategoryTypeId: 1, value: 'RequestRegistrationCredit', displayValue: 'Request Registration Credit', description: 'Request Registration Credit', sortOrder: 999999, active: true });
        this._dictionary.add('65', { id: 65, businessTransactionCategoryTypeId: 1, value: 'RemoteTestInstructionPermit', displayValue: 'Remote Test Instruction Permit', description: 'Remote Test Instruction Permit', sortOrder: 999999, active: true });
        this._dictionary.add('66', { id: 66, businessTransactionCategoryTypeId: 1, value: 'eTitleTransfer', displayValue: 'eTitle Transfer', description: 'eTitle Transfer', sortOrder: 999999, active: true });
        this._dictionary.add('67', { id: 67, businessTransactionCategoryTypeId: 1, value: 'ReleaseLien', displayValue: 'Release Lien', description: 'Release Lien', sortOrder: 999999, active: true });
        this._dictionary.add('68', { id: 68, businessTransactionCategoryTypeId: 1, value: 'CompliancePayment', displayValue: 'Compliance Payment', description: 'Compliance Payment', sortOrder: 999999, active: true });
        this._dictionary.add('69', { id: 69, businessTransactionCategoryTypeId: 1, value: 'VehicleMVR', displayValue: 'Vehicle MVR', description: 'Vehicle MVR', sortOrder: 999999, active: true });
        this._dictionary.add('70', { id: 70, businessTransactionCategoryTypeId: 1, value: 'DriverMVR', displayValue: 'Driver MVR', description: 'Driver MVR', sortOrder: 999999, active: true });
        this._dictionary.add('71', { id: 71, businessTransactionCategoryTypeId: 1, value: 'AddReleaseLien', displayValue: 'Add or Release Lien', description: 'Add or Release Lien', sortOrder: 999999, active: true });
        this._dictionary.add('72', { id: 72, businessTransactionCategoryTypeId: 1, value: 'CorrectLien', displayValue: 'Correct Lien', description: 'Correct Lien', sortOrder: 999999, active: true });
        this._dictionary.add('73', { id: 73, businessTransactionCategoryTypeId: 6, value: 'CustomerDigitalRefundRequestReversal', displayValue: 'Customer Digital Refund Request Reversal', description: 'Customer Digital Refund Request Reversal', sortOrder: 999999, active: true });
        this._dictionary.add('74', { id: 74, businessTransactionCategoryTypeId: 1, value: 'TabReplacement', displayValue: 'Tab Replacement', description: 'Tab Replacement', sortOrder: 999999, active: true });
        this._dictionary.add('75', { id: 75, businessTransactionCategoryTypeId: 1, value: 'ModifyCommercialEnvelopePermit', displayValue: 'Modify Commercial Envelope Permit', description: 'Modify Commercial Envelope Permit', sortOrder: 999999, active: true });
        this._dictionary.add('1065', { id: 1065, businessTransactionCategoryTypeId: 1, value: 'MiscellaneousPurchase', displayValue: 'Miscellaneous Purchase', description: 'Miscellaneous Purchase', sortOrder: 999999, active: true });
        this._dictionary.add('1066', { id: 1066, businessTransactionCategoryTypeId: 1, value: 'StandAloneCommercialSkillTest', displayValue: 'Stand Alone Commercial Skill Test', description: 'Stand Alone Commercial Skill Test', sortOrder: 999999, active: false });
        this._dictionary.add('1067', { id: 1067, businessTransactionCategoryTypeId: 1, value: 'StandAloneNonCommercialSkillTest', displayValue: 'Stand Alone Non Commercial Skill Test', description: 'Stand Alone Non Commercial Skill Test', sortOrder: 999999, active: true });
        this._dictionary.add('1068', { id: 1068, businessTransactionCategoryTypeId: 1, value: 'StandAloneKnowledgeTest', displayValue: 'Stand Alone Knowledge Test', description: 'Stand Alone Knowledge Test', sortOrder: 999999, active: true });
        this._dictionary.add('1069', { id: 1069, businessTransactionCategoryTypeId: 1, value: 'StandAloneVisionScreening', displayValue: 'Stand Alone Vision Screening', description: 'Stand Alone Vision Screening', sortOrder: 999999, active: true });
        this._dictionary.add('1070', { id: 1070, businessTransactionCategoryTypeId: 1, value: 'StandAloneMotorcycleSkillTest', displayValue: 'Stand Alone Motorcycle Skill Test', description: 'Stand Alone Motorcycle Skill Test', sortOrder: 999999, active: true });
        this._dictionary.add('1071', { id: 1071, businessTransactionCategoryTypeId: 1, value: 'StandAloneAddRemoveRestrictions', displayValue: 'Stand Alone Add Remove Restrictions', description: 'Stand Alone Add Remove Restrictions', sortOrder: 999999, active: false });
        this._dictionary.add('1072', { id: 1072, businessTransactionCategoryTypeId: 1, value: 'OriginalFTReportExciseTax', displayValue: 'Original FT Report Excise Tax', description: 'Original FT Report Excise Tax', sortOrder: 999999, active: true });
        this._dictionary.add('1073', { id: 1073, businessTransactionCategoryTypeId: 1, value: 'OriginalFTReportUSTTax', displayValue: 'Original FT Report UST Tax', description: 'Original FT Report UST Tax', sortOrder: 999999, active: true });
        this._dictionary.add('1074', { id: 1074, businessTransactionCategoryTypeId: 1, value: 'AmendedFTReportExciseTax', displayValue: 'Amended FT Report Excise Tax ', description: 'Amended FT Report Excise Tax', sortOrder: 999999, active: true });
        this._dictionary.add('1075', { id: 1075, businessTransactionCategoryTypeId: 4, value: 'AmendedFTReportExciseTaxCR', displayValue: 'Amended FT Report Excise Tax CR', description: 'Amended FT Report Excise Tax CR', sortOrder: 999999, active: false });
        this._dictionary.add('1076', { id: 1076, businessTransactionCategoryTypeId: 1, value: 'AmendedFTReportUSTTax', displayValue: 'Amended FT Report UST Tax', description: 'Amended FT Report UST Tax', sortOrder: 999999, active: true });
        this._dictionary.add('1077', { id: 1077, businessTransactionCategoryTypeId: 3, value: 'USTTaxCredit', displayValue: 'UST Tax Credit', description: 'UST Tax Credit', sortOrder: 999999, active: true });
        this._dictionary.add('1078', { id: 1078, businessTransactionCategoryTypeId: 1, value: 'ExciseTaxPenaltyInterest', displayValue: 'Excise Tax Penalties and Interest', description: 'Excise Tax Penalties and Interest', sortOrder: 999999, active: true });
        this._dictionary.add('1079', { id: 1079, businessTransactionCategoryTypeId: 1, value: 'USTTaxPenaltyInterest', displayValue: 'UST Tax Penalties and Interest', description: 'UST Tax Penalties and Interest', sortOrder: 999999, active: true });
        this._dictionary.add('1080', { id: 1080, businessTransactionCategoryTypeId: 1, value: 'CancelTRP', displayValue: 'Cancel Temporary Registration Plate (TRP)', description: 'Cancel Temporary Registration Plate (TRP)', sortOrder: 999999, active: true });
        this._dictionary.add('1081', { id: 1081, businessTransactionCategoryTypeId: 3, value: 'ExciseTaxCredit', displayValue: 'Excise Tax Credit', description: 'Excise Tax Credit', sortOrder: 999999, active: true });
        this._dictionary.add('1082', { id: 1082, businessTransactionCategoryTypeId: 7, value: 'FundCharitableOrganization', displayValue: 'Fund Charitable Organization', description: 'Fund Charitable Organization', sortOrder: 999999, active: true });
        this._dictionary.add('1083', { id: 1083, businessTransactionCategoryTypeId: 1, value: 'AuditAssessmentExciseTax', displayValue: 'Audit Assessment Excise Tax', description: 'Audit Assessment Excise Tax', sortOrder: 999999, active: true });
        this._dictionary.add('1084', { id: 1084, businessTransactionCategoryTypeId: 1, value: 'NoticeofAssessmentExciseTax', displayValue: 'Notice of Assessment Excise Tax', description: 'Notice of Assessment Excise Tax', sortOrder: 999999, active: true });
        this._dictionary.add('1085', { id: 1085, businessTransactionCategoryTypeId: 1, value: 'FuelTaxAdjustmentExciseTax', displayValue: 'Fuel Tax Adjustment Excise Tax', description: 'Fuel Tax Adjustment Excise Tax', sortOrder: 999999, active: true });
        this._dictionary.add('1086', { id: 1086, businessTransactionCategoryTypeId: 1, value: 'AuditAssessmentUST', displayValue: 'Audit Assessment UST', description: 'Audit Assessment UST', sortOrder: 999999, active: true });
        this._dictionary.add('1087', { id: 1087, businessTransactionCategoryTypeId: 1, value: 'NoticeofAssessmentUST', displayValue: 'Notice of Assessment UST', description: 'Notice of Assessment UST', sortOrder: 999999, active: true });
        this._dictionary.add('1088', { id: 1088, businessTransactionCategoryTypeId: 1, value: 'FuelTaxAdjustmentUST', displayValue: 'Fuel Tax Adjustment UST', description: 'Fuel Tax Adjustment UST', sortOrder: 999999, active: true });
        this._dictionary.add('1089', { id: 1089, businessTransactionCategoryTypeId: 1, value: 'FTFundCustomerAccount', displayValue: 'FT Fund Customer Account', description: 'FT Fund Customer Account', sortOrder: 999999, active: true });
        this._dictionary.add('1090', { id: 1090, businessTransactionCategoryTypeId: 1, value: 'ConversionAADA', displayValue: 'Conversion - AADA', description: 'Conversion - AADA', sortOrder: 999999, active: true });
        this._dictionary.add('1091', { id: 1091, businessTransactionCategoryTypeId: 1, value: 'ConversionAQF', displayValue: 'Conversion - AQF', description: 'Conversion - AQF', sortOrder: 999999, active: true });
        this._dictionary.add('1092', { id: 1092, businessTransactionCategoryTypeId: 1, value: 'ConversionAviation', displayValue: 'Conversion - Aviation', description: 'Conversion - Aviation', sortOrder: 999999, active: true });
        this._dictionary.add('1093', { id: 1093, businessTransactionCategoryTypeId: 1, value: 'ConversionDCK', displayValue: 'Conversion - DCK', description: 'Conversion - DCK', sortOrder: 999999, active: true });
        this._dictionary.add('1094', { id: 1094, businessTransactionCategoryTypeId: 1, value: 'ConversionDealer', displayValue: 'Conversion - Dealer', description: 'Conversion - Dealer', sortOrder: 999999, active: true });
        this._dictionary.add('1095', { id: 1095, businessTransactionCategoryTypeId: 1, value: 'ConversionDriverLicense', displayValue: 'Conversion - Driver License', description: 'Conversion - Driver License', sortOrder: 999999, active: true });
        this._dictionary.add('1096', { id: 1096, businessTransactionCategoryTypeId: 1, value: 'ConversionGameAndFish', displayValue: 'Conversion - Game and Fish', description: 'Conversion - Game and Fish', sortOrder: 999999, active: true });
        this._dictionary.add('1097', { id: 1097, businessTransactionCategoryTypeId: 1, value: 'ConversionIRP', displayValue: 'Conversion - IRP', description: 'Conversion - IRP', sortOrder: 999999, active: true });
        this._dictionary.add('1098', { id: 1098, businessTransactionCategoryTypeId: 1, value: 'ConversionMCarrier', displayValue: 'Conversion - MCarrier', description: 'Conversion - MCarrier', sortOrder: 999999, active: true });
        this._dictionary.add('1099', { id: 1099, businessTransactionCategoryTypeId: 1, value: 'ConversionMiscellaneousTransaction', displayValue: 'Conversion - Miscellaneous Transaction', description: 'Conversion - Miscellaneous Transaction', sortOrder: 999999, active: true });
        this._dictionary.add('1100', { id: 1100, businessTransactionCategoryTypeId: 1, value: 'ConversionMotorCarrier', displayValue: 'Conversion - Motor Carrier', description: 'Conversion - Motor Carrier', sortOrder: 999999, active: true });
        this._dictionary.add('1101', { id: 1101, businessTransactionCategoryTypeId: 1, value: 'ConversionPPVPayment', displayValue: 'Conversion - PPV Payment', description: 'Conversion - PPV Payment', sortOrder: 999999, active: true });
        this._dictionary.add('1102', { id: 1102, businessTransactionCategoryTypeId: 1, value: 'ConversionRegistration', displayValue: 'Conversion - Registration', description: 'Conversion - Registration', sortOrder: 999999, active: true });
        this._dictionary.add('1103', { id: 1103, businessTransactionCategoryTypeId: 1, value: 'ConversionTransport', displayValue: 'Conversion - Transport', description: 'Conversion - Transport', sortOrder: 999999, active: true });
        this._dictionary.add('1104', { id: 1104, businessTransactionCategoryTypeId: 1, value: 'ConversionWeightsAndPermits', displayValue: 'Conversion - Weights And Permits', description: 'Conversion - Weights And Permits', sortOrder: 999999, active: true });
        this._dictionary.add('1105', { id: 1105, businessTransactionCategoryTypeId: 1, value: 'EnforcementTransactions', displayValue: 'Enforcement Transactions', description: 'Enforcement Transactions', sortOrder: 999999, active: true });
        this._dictionary.add('1106', { id: 1106, businessTransactionCategoryTypeId: 1, value: 'POETransactions', displayValue: 'POE Transactions', description: 'POE Transactions', sortOrder: 999999, active: true });
        this._dictionary.add('1107', { id: 1107, businessTransactionCategoryTypeId: 1, value: 'MobileUnitTransactions', displayValue: 'Mobile Unit Transactions', description: 'Mobile Unit Transactions', sortOrder: 999999, active: true });
        this._dictionary.add('1108', { id: 1108, businessTransactionCategoryTypeId: 1, value: 'TechSupportTransactions', displayValue: 'Tech Support Transactions', description: 'Tech Support Transactions', sortOrder: 999999, active: true });
        this._dictionary.add('1109', { id: 1109, businessTransactionCategoryTypeId: 1, value: 'PermitTransactions', displayValue: 'Permit Transactions', description: 'Permit Transactions', sortOrder: 999999, active: true });
        this._dictionary.add('1110', { id: 1110, businessTransactionCategoryTypeId: 1, value: 'InspectionTransactions', displayValue: 'Inspection Transactions', description: 'Inspection Transactions', sortOrder: 999999, active: true });
        this._dictionary.add('1111', { id: 1111, businessTransactionCategoryTypeId: 1, value: 'CountyMiscellaneousPurchase', displayValue: 'County Miscellaneous Purchase', description: 'County Miscellaneous Purchase', sortOrder: 999999, active: true });
        this._dictionary.add('1112', { id: 1112, businessTransactionCategoryTypeId: 1, value: 'AuditAssessmentExcisePenaltiesInterest', displayValue: 'Audit Assessment Excise Tax Penalties and Interest', description: 'Audit Assessment Excise Tax Penalties and Interest', sortOrder: 999999, active: true });
        this._dictionary.add('1113', { id: 1113, businessTransactionCategoryTypeId: 1, value: 'NoticeofAssessmentExciseTaxPenaltiesInterest', displayValue: 'Notice of Assessment Excise Tax Penalties and Interest', description: 'Notice of Assessment Excise Tax Penalties and Interest', sortOrder: 999999, active: true });
        this._dictionary.add('1114', { id: 1114, businessTransactionCategoryTypeId: 1, value: 'FuelTaxAdjustmentExciseTaxPenaltiesInterest', displayValue: 'Fuel Tax Adjustment Excise Tax Penalties and Interest', description: 'Fuel Tax Adjustment Excise Tax Penalties and Interest', sortOrder: 999999, active: true });
        this._dictionary.add('1115', { id: 1115, businessTransactionCategoryTypeId: 1, value: 'FuelTaxAdjustmentUSTPenaltiesInterest', displayValue: 'Fuel Tax Adjustment UST Penalties and Interest', description: 'Fuel Tax Adjustment UST Penalties and Interest', sortOrder: 999999, active: true });
        this._dictionary.add('1116', { id: 1116, businessTransactionCategoryTypeId: 1, value: 'AuditAssessmentUSTPenaltiesInterest', displayValue: 'Audit Assessment UST Penalties and Interest', description: 'Audit Assessment UST Penalties and Interest', sortOrder: 999999, active: true });
        this._dictionary.add('1117', { id: 1117, businessTransactionCategoryTypeId: 1, value: 'NoticeofAssessmentUSTPenaltiesInterest', displayValue: 'Notice of Assessment UST Penalties and Interest', description: 'Notice of Assessment UST Penalties and Interest', sortOrder: 999999, active: true });
        this._dictionary.add('1118', { id: 1118, businessTransactionCategoryTypeId: 3, value: 'AuditAssessmentExciseTaxCredit', displayValue: 'Audit Assessment Excise Tax Credit', description: 'Audit Assessment Excise Tax Credit', sortOrder: 999999, active: true });
        this._dictionary.add('1119', { id: 1119, businessTransactionCategoryTypeId: 3, value: 'NoticeofAssessmentExciseTaxCredit', displayValue: 'Notice of Assessment Excise Tax Credit', description: 'Notice of Assessment Excise Tax Credit', sortOrder: 999999, active: true });
        this._dictionary.add('1120', { id: 1120, businessTransactionCategoryTypeId: 3, value: 'FuelTaxAdjustmentExciseTaxCredit', displayValue: 'Fuel Tax Adjustment Excise Tax Credit', description: 'Fuel Tax Adjustment Excise Tax Credit', sortOrder: 999999, active: true });
        this._dictionary.add('1121', { id: 1121, businessTransactionCategoryTypeId: 3, value: 'FuelTaxAdjustmentUSTCredit', displayValue: 'Fuel Tax Adjustment UST Credit', description: 'Fuel Tax Adjustment UST Credit', sortOrder: 999999, active: true });
        this._dictionary.add('1122', { id: 1122, businessTransactionCategoryTypeId: 3, value: 'AuditAssessmentUSTCredit', displayValue: 'Audit Assessment UST Credit', description: 'Audit Assessment UST Credit', sortOrder: 999999, active: true });
        this._dictionary.add('1123', { id: 1123, businessTransactionCategoryTypeId: 3, value: 'NoticeofAssessmentUSTCredit', displayValue: 'Notice of Assessment UST Credit', description: 'Notice of Assessment UST Credit', sortOrder: 999999, active: true });
        this._dictionary.add('1124', { id: 1124, businessTransactionCategoryTypeId: 1, value: 'TnRCorrections', displayValue: 'TnR Corrections Old', description: 'TnR Corrections Old', sortOrder: 999999, active: false });
        this._dictionary.add('1125', { id: 1125, businessTransactionCategoryTypeId: 1, value: 'TnRRecreate', displayValue: 'TnR Recreate', description: 'TnR Recreate', sortOrder: 999999, active: true });
        this._dictionary.add('1126', { id: 1126, businessTransactionCategoryTypeId: 1, value: 'CancelCredential', displayValue: 'Cancel Credential', description: 'Cancel Credential', sortOrder: 999999, active: true });
        this._dictionary.add('1133', { id: 1133, businessTransactionCategoryTypeId: 1, value: 'RecreateTRP', displayValue: 'Recreate TRP', description: 'Recreate TRP', sortOrder: 999999, active: true });
        this._dictionary.add('1134', { id: 1134, businessTransactionCategoryTypeId: 1, value: 'DuplicatePlate', displayValue: 'Duplicate Plate', description: 'Customer has the ability to order a second specialty plate', sortOrder: 999999, active: true });
        this._dictionary.add('1135', { id: 1135, businessTransactionCategoryTypeId: 1, value: 'TransferCustomerAccount', displayValue: 'Transfer Customer Account', description: 'Transfer Customer Account', sortOrder: 999999, active: true });
        this._dictionary.add('1137', { id: 1137, businessTransactionCategoryTypeId: 1, value: 'Correction', displayValue: 'TnR Corrections', description: 'TnR Corrections', sortOrder: 999999, active: true });
        this._dictionary.add('1139', { id: 1139, businessTransactionCategoryTypeId: 1, value: 'FuelTaxAdjustmentExciseTaxACHReturn', displayValue: 'Fuel Tax Adjustment Excise Tax ACH Return', description: 'Fuel Tax Adjustment Excise Tax ACH Return', sortOrder: 999999, active: true });
        this._dictionary.add('1140', { id: 1140, businessTransactionCategoryTypeId: 1, value: 'FuelTaxAdjustmentUSTACHReturn', displayValue: 'Fuel Tax Adjustment UST ACH Return', description: 'Fuel Tax Adjustment UST ACH Return', sortOrder: 999999, active: true });
        this._dictionary.add('1141', { id: 1141, businessTransactionCategoryTypeId: 3, value: 'FuelTaxAdjustmentExciseACHReturnTaxCredit', displayValue: 'Fuel Tax Adjustment Excise ACH Return Tax Credit', description: 'Fuel Tax Adjustment Excise ACH Return Tax Credit', sortOrder: 999999, active: true });
        this._dictionary.add('1142', { id: 1142, businessTransactionCategoryTypeId: 3, value: 'FuelTaxAdjustmentUSTACHReturnTaxCredit', displayValue: 'Fuel Tax Adjustment UST ACH Return Tax Credit', description: 'Fuel Tax Adjustment UST ACH Return Tax Credit', sortOrder: 999999, active: true });
        this._dictionary.add('1143', { id: 1143, businessTransactionCategoryTypeId: 1, value: 'MCAChangeName', displayValue: 'Motor Carrier Edit Account', description: 'Motor Carrier Account Change Name', sortOrder: 999999, active: true });
        this._dictionary.add('1144', { id: 1144, businessTransactionCategoryTypeId: 1, value: 'MCAStraightRenewal', displayValue: 'Motor Carrier Straight Fleet Renewal', description: 'Motor Carrier Straight Fleet Renewal', sortOrder: 999999, active: true });
        this._dictionary.add('1145', { id: 1145, businessTransactionCategoryTypeId: 1, value: 'MCACreateIFTA', displayValue: 'Create IFTA Account', description: 'Create IFTA Account', sortOrder: 999999, active: true });
        this._dictionary.add('1146', { id: 1146, businessTransactionCategoryTypeId: 1, value: 'MVDClearingAccountAdjustment', displayValue: 'MVD Clearing Account Adjustment', description: 'Adjustments done to the MVD Clearing Account', sortOrder: 999999, active: true });
        this._dictionary.add('1147', { id: 1147, businessTransactionCategoryTypeId: 1, value: 'CommercialPermit', displayValue: 'Commercial Permit', description: 'Commercial Permit', sortOrder: 999999, active: true });
        this._dictionary.add('1148', { id: 1148, businessTransactionCategoryTypeId: 1, value: 'MCADeleteVehicle', displayValue: 'Motor Carrier Delete Vehicle', description: 'Motor Carrier Delete Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('1149', { id: 1149, businessTransactionCategoryTypeId: 1, value: 'MCAAddVehicle', displayValue: 'Motor Carrier Add Vehicle', description: 'Motor Carrier Add Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('1150', { id: 1150, businessTransactionCategoryTypeId: 1, value: 'MCARenewFleet', displayValue: 'Motor Carrier Fleet Renewal', description: 'Motor Carrier Fleet Renewal', sortOrder: 999999, active: true });
        this._dictionary.add('1151', { id: 1151, businessTransactionCategoryTypeId: 1, value: 'MCAAddVehicleTransfer', displayValue: 'Motor Carrier Add Vehicle with Transfer', description: 'Motor Carrier Add Vehicle with Transfer', sortOrder: 999999, active: true });
        this._dictionary.add('1152', { id: 1152, businessTransactionCategoryTypeId: 1, value: 'MCAReplacePlate', displayValue: 'Motor Carrier Replace Plate', description: 'Motor Carrier Replace Plate', sortOrder: 999999, active: true });
        this._dictionary.add('1153', { id: 1153, businessTransactionCategoryTypeId: 1, value: 'MCACabCardCorrection', displayValue: 'Motor Carrier Cab Card Correction', description: 'Motor Carrier Cab Card Correction', sortOrder: 999999, active: true });
        this._dictionary.add('1154', { id: 1154, businessTransactionCategoryTypeId: 1, value: 'MCADAmendVehicle', displayValue: 'Motor Carrier Amend Vehicle', description: 'Motor Carrier Amend Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('1155', { id: 1155, businessTransactionCategoryTypeId: 1, value: 'MCAChangeFleetType', displayValue: 'Motor Carrier Change Fleet Type', description: 'Motor Carrier Change Fleet Type', sortOrder: 999999, active: true });
        this._dictionary.add('1156', { id: 1156, businessTransactionCategoryTypeId: 1, value: 'CancelCommercialPermit', displayValue: 'Cancel Commercial Permit', description: 'Cancel Commercial Permit', sortOrder: 999999, active: true });
        this._dictionary.add('1158', { id: 1158, businessTransactionCategoryTypeId: 1, value: 'ModifyCommercialPermit', displayValue: 'Modify Commercial Permit', description: 'Modify Commercial Permit', sortOrder: 999999, active: true });
        this._dictionary.add('1165', { id: 1165, businessTransactionCategoryTypeId: 1, value: 'MCAReplaceDecals', displayValue: 'Motor Carrier Replace IFTA Decals', description: 'Motor Carrier Replace IFTA Decals', sortOrder: 999999, active: true });
        this._dictionary.add('1169', { id: 1169, businessTransactionCategoryTypeId: 1, value: 'DealerOffPremisePermit', displayValue: 'Dealer Off Premise Permit', description: 'Dealer Off Premise Permit', sortOrder: 999999, active: true });
        this._dictionary.add('1173', { id: 1173, businessTransactionCategoryTypeId: 1, value: 'DealerLicenseRenewal', displayValue: 'Dealer License Renewal', description: 'Dealer License Renewal', sortOrder: 999999, active: true });
        this._dictionary.add('1175', { id: 1175, businessTransactionCategoryTypeId: 1, value: 'MCAGrowUpTPA', displayValue: 'Motor Carrier Grow Up TPA', description: 'Motor Carrier Grow Up TPA', sortOrder: 999999, active: true });
        this._dictionary.add('1176', { id: 1176, businessTransactionCategoryTypeId: 1, value: 'MCIFTAAddBond', displayValue: 'IFTA Add Bond', description: 'IFTA Add Bond', sortOrder: 999999, active: true });
        this._dictionary.add('1177', { id: 1177, businessTransactionCategoryTypeId: 1, value: 'MCIFTAUpdateBond', displayValue: 'IFTA Update Bond', description: 'IFTA Update Bond', sortOrder: 999999, active: true });
        this._dictionary.add('1178', { id: 1178, businessTransactionCategoryTypeId: 1, value: 'MCIFTAReleaseBond', displayValue: 'IFTA Release Bond', description: 'IFTA Release Bond', sortOrder: 999999, active: true });
        this._dictionary.add('1180', { id: 1180, businessTransactionCategoryTypeId: 1, value: 'ReverseCompliancePayment', displayValue: 'Reverse Compliance Payment', description: 'Reverse Compliance Payment', sortOrder: 999999, active: true });
        this._dictionary.add('1181', { id: 1181, businessTransactionCategoryTypeId: 1, value: 'MCAudit', displayValue: 'Motor Carrier Audit', description: 'Motor Carrier Audit', sortOrder: 999999, active: true });
        this._dictionary.add('1182', { id: 1182, businessTransactionCategoryTypeId: 1, value: 'AddAircraftRegistration', displayValue: 'Add Aircraft Registration', description: 'Add Aircraft Registration', sortOrder: 999999, active: true });
        this._dictionary.add('1183', { id: 1183, businessTransactionCategoryTypeId: 1, value: 'UpdAircraftRegistration', displayValue: 'Update Aircraft Registration', description: 'Update Aircraft Registration', sortOrder: 999999, active: true });
        this._dictionary.add('1184', { id: 1184, businessTransactionCategoryTypeId: 1, value: 'ChgAircraftOwnership', displayValue: 'Change Aircraft Ownership', description: 'Change Aircraft Ownership', sortOrder: 999999, active: true });
        this._dictionary.add('1185', { id: 1185, businessTransactionCategoryTypeId: 1, value: 'PayAircraftInvoice', displayValue: 'Pay Aircraft Invoice', description: 'Pay Aircraft Invoice', sortOrder: 999999, active: true });
        this._dictionary.add('1186', { id: 1186, businessTransactionCategoryTypeId: 1, value: 'PenaltyAircraft', displayValue: 'Penalty Aircraft', description: 'Penalty Aircraft', sortOrder: 999999, active: true });
        this._dictionary.add('1187', { id: 1187, businessTransactionCategoryTypeId: 1, value: 'AircraftAssessment', displayValue: 'Aircraft Assessment', description: 'Aircraft Assessment', sortOrder: 999999, active: true });
        this._dictionary.add('1188', { id: 1188, businessTransactionCategoryTypeId: 1, value: 'ReactivateAircraftRegistration', displayValue: 'Reactivate Aircraft Registration', description: 'Reactivate Aircraft Registration', sortOrder: 999999, active: true });
        this._dictionary.add('1189', { id: 1189, businessTransactionCategoryTypeId: 1, value: 'VoidSupplement', displayValue: 'Void Supplement', description: 'Void Supplement', sortOrder: 999999, active: true });
        this._dictionary.add('1190', { id: 1190, businessTransactionCategoryTypeId: 1, value: 'MCAVehicleMaintenance', displayValue: 'Motor Carrier Vehicle Maintenance', description: 'Motor Carrier Vehicle Maintenance', sortOrder: 999999, active: true });
        this._dictionary.add('1191', { id: 1191, businessTransactionCategoryTypeId: 1, value: 'MCAVehicleCorrection', displayValue: 'Motor Carrier Vehicle Correction', description: 'Motor Carrier Vehicle Correction', sortOrder: 999999, active: true });
        this._dictionary.add('1192', { id: 1192, businessTransactionCategoryTypeId: 1, value: 'VehicleInspection', displayValue: 'Vehicle Inspection', description: 'Vehicle Inspection', sortOrder: 999999, active: true });
        this._dictionary.add('1193', { id: 1193, businessTransactionCategoryTypeId: 1, value: 'VoidCancelRegistration', displayValue: 'Void Cancel Registration', description: 'Voids a cancel registration transaction', sortOrder: 999999, active: true });
        this._dictionary.add('1194', { id: 1194, businessTransactionCategoryTypeId: 1, value: 'StandAloneVoterRegistration', displayValue: 'Stand Alone Voter Registration', description: 'Stand Alone Voter Registration', sortOrder: 999999, active: true });
        this._dictionary.add('1195', { id: 1195, businessTransactionCategoryTypeId: 1, value: 'MCAMaintainIFTALicense', displayValue: 'Motor Carrier Maintain IFTA License', description: 'Motor Carrier Maintain IFTA License', sortOrder: 999999, active: true });
        this._dictionary.add('1198', { id: 1198, businessTransactionCategoryTypeId: 1, value: 'UnusedBalanceTransfer', displayValue: 'Reversions ARS 28-364(E)(2)', description: 'Reversions ARS 28-364(E)(2) - 5 year', sortOrder: 999999, active: true });
        this._dictionary.add('1199', { id: 1199, businessTransactionCategoryTypeId: 1, value: 'IFTAUnclaimedProperty', displayValue: 'Unclaimed ARS 28-5725 (A)', description: 'Unclaimed ARS 28-5725 (A) - IFTA 3 year', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IBusinessTransactionType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IBusinessTransactionType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IBusinessTransactionType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IBusinessTransactionType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IBusinessTransactionType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
